/**
 * Prettify time (from numeric value)
 *
 * E.g.
 * 			105.44 -> '01:45' (one minute and 45 seconds)
 *
 * @param {number} timeNumericValue
 * @returns {string}
 */
export function prettifyTimeFromNumeric(timeNumericValue, options = {
    ceil: false,
    includeFraction: false,
    padMinutes: false,
}) {
    const secondsInTotalRounded = options.ceil
        ? Math.ceil(timeNumericValue)
        : Math.floor(timeNumericValue);
    // Parse data
    const min = Math.floor(secondsInTotalRounded / 60);
    const sec = secondsInTotalRounded % 60;
    // Prepare output
    // Minutes output - padded or not based on configuration parsed
    const minOutput = options.padMinutes ? String(min).padStart(2, '0') : min;
    // Seconds - Always pad to be two characters
    const secOutput = String(sec).padStart(2, '0');
    let output = `${minOutput}:${secOutput}`;
    // Include fraction of a second?
    if (options.includeFraction) {
        output += (timeNumericValue % 1)
            .toFixed(1) // Fixed 1 digit fraction
            .replace('0.', '.'); // Split prepending zero
    }
    return output;
}
/**
 * Numeric from time
 *
 * E.g.
 * 			'01:45' -> 105.44 (one minute and 45 seconds)
 *
 * @param {string} timeNumericValue
 * @param {boolean} includeFraction
 * @returns {number} Numeric value
 */
export function numericFromTime(time, _includeFraction = false) {
    const parts = time.split(/[:\.]/);
    // If no divider were found, just parse time to number
    if (parts.length === 1) {
        return Number(parts[0]);
    }
    // Accumulate value based on parts
    return parts.reduce((total, partStr, index) => {
        const val = Number(partStr);
        const scalarIndex = parts.length - index - 1; // Sec = 0, Min = 1, Hour = 2
        const scalar = Math.pow(60, scalarIndex); // Sec = 1, Min = 60, Hour = 3600
        total += val * scalar;
        return total;
    }, 0);
}
//# sourceMappingURL=time.js.map